import '@/assets/styles/base.scss';
import { initPassportSDK } from '../utils/passport';

import App from './App-card-end.svelte';

import { setupErrorMonitor } from '@/utils/errorMonitor';
import { reportP3, updateUid } from '@/utils/fmpTrack';
import { smallFlowInit } from '@/utils/smallFlow';

updateUid();
setupErrorMonitor();
window.isUseSlider = false;
initPassportSDK();

smallFlowInit();
reportP3();

const appDom = document.getElementById('app');

if (appDom) {
    appDom.innerHTML = '';
}

const app = new App({
    target: document.getElementById('app')!
});

export default app;
